<template>
  <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.6152 7.46153C6.6348 7.46153 7.46135 6.63498 7.46135 5.61538C7.46135 4.59578 6.6348 3.76923 5.6152 3.76923C4.59559 3.76923 3.76904 4.59578 3.76904 5.61538C3.76904 6.63498 4.59559 7.46153 5.6152 7.46153Z" stroke="#4F4C4D" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.2308 5.61538C10.2308 9.76923 5.61538 13 5.61538 13C5.61538 13 1 9.76923 1 5.61538C1 4.39131 1.48626 3.21737 2.35181 2.35181C3.21737 1.48626 4.39131 1 5.61538 1C6.83946 1 8.0134 1.48626 8.87895 2.35181C9.74451 3.21737 10.2308 4.39131 10.2308 5.61538V5.61538Z" stroke="#4F4C4D" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
  
<script>
  export default {
    name: 'SvgMarker'
  }
</script>